import React, { useState, useEffect, useRef } from "react";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { RadioButton } from "primereact/radiobutton";
import "primereact/resources/themes/lara-light-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import { MultiSelect } from "primereact/multiselect";
import Loader from "../../Shared/Loader/Loader";
import APIConstant from "../../../utils/pathConstants";
import api from "../../../utils/apiClient";
import Toast from '../../Shared/Toast/Toast';
import CommonConfig from "../../../utils/constant";
import { FloatLabel } from "primereact/floatlabel";
import { useCatchResponse } from '../../../utils/useCatchResponse';


const AddEditGraceMarkConfiguration = (props) => {
    const { catchResponse } = useCatchResponse();
    const [securityUserID, setSecurityUserID] = useState("");
    const [classList, setClassList] = useState([]);
    const [teachersList, setTeachersList] = useState([]);
    const [titleName, setTitleName] = useState('');
    const [titleNameErr, setTitleNameErr] = useState(false);
    const [titleNameErrText, setTitleNameErrText] = useState('');
    const [className, setClassName] = useState([]);
    const [giver, setGiver] = useState(null);
    const [overallLimit, setOverallLimit] = useState(true);
    const [overallLimitMark, setOverallLimitMark] = useState('');
    const [subjectLimit, setSubjectLimit] = useState(true);
    const [subjectLimitMark, setSubjectLimitMark] = useState('');
    const [showInResult, setShowInResult] = useState(true);
    const [symbol, setSymbol] = useState("");
    const [graceNote, setGraceNote] = useState(true);
    const [reMark, setRemark] = useState("");
    const [selectedYear, setSelectedYear] = useState('');
    const submitButtonRef = useRef(null);
    const titleNameRef = useRef(null);
    useEffect(() => {
        const loginData = CommonConfig.loginData();
        setSecurityUserID(loginData?._id);

        // Ensure focus after modal renders
        setTimeout(() => {
            titleNameRef.current?.focus();
        }, 100);
    }, []);

    useEffect(() => {
        const loginData = CommonConfig.loginData();
        setSecurityUserID(loginData?._id);
        GetClassList(loginData?._id, props?.masterData?.FinancialYear || props?.financialYearId);
        GetTeachersList(loginData?.id);
        if (props?.configId) {
            setSelectedYear(props?.masterData?.FinancialYear);
            setTitleName(props?.masterData?.TemplateName);
            setClassName(props?.masterData?.ClassId ? props?.masterData?.ClassId.split(',') : []);
            setGiver(props?.masterData?.ToGivenBy || '');
            setOverallLimit(props?.masterData?.IsOverAllMarkLimit);
            setOverallLimitMark(props?.masterData?.OverAllLimit);
            setSubjectLimit(props?.masterData?.IsSubjectMarkLimit);
            setSubjectLimitMark(props?.masterData?.SubjectLimit);
            setShowInResult(props?.masterData?.IsShowInResult);
            setSymbol(props?.masterData?.Symbol);
            setGraceNote(props?.masterData?.IsGraceMarkRemark);
            setRemark(props?.masterData?.Remark);
        } else {
            setSelectedYear(props?.financialYearId);
        }
    }, []);

    const GetClassList = async (id, academicYearId) => {
        try {
            let data = {
                UserID: id,
                FinancialYearId: academicYearId
            }
            await api.post(APIConstant.path.getClassList, data).then(async response => {
                let res = response;
                if (res.success) {
                    setClassList(
                        Array.from(
                            new Map(
                                res?.data?.filter(x => x?.Status === 'Active')?.map((x) => [
                                    x?.ClassId,
                                    {
                                        ...x,
                                        value: x?.ClassId,
                                        label: `${x?.ClassName}-${x?.MediumName}-${x?.Board}`
                                    }
                                ])
                            ).values()
                        )
                    );

                    Loader.hide();
                }
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    }

    const GetTeachersList = async (id) => {
        try {
            let data = {
                UserID: id,
            }
            await api.post(APIConstant.path.getUser, data).then(async response => {
                let res = response;
                if (res.success) {
                    const dataList = res.data.filter((x) => x.UserType === 'Teacher' && x?.Status === 'Active').map((y) => ({
                        ...y,
                        label: y.Name,
                        value: y._id
                    }));
                    setTeachersList(dataList);
                    Loader.hide();
                }
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    }

    const onCancel = () => {
        props.onCancel();
        setTitleName('');
        setClassName([]);
    }

    const validate = () => {
        let formIsValid = true;
        if (CommonConfig.isEmpty(titleName)) {
            formIsValid = false;
            setTitleNameErr(true);
            setTitleNameErrText("Title Name is required");
        } else {
            setTitleNameErr(false);
            setTitleNameErrText("");
        }
        return formIsValid;
    };

    const AddUpdateTemplate = async (e) => {
        if (validate(e)) {
            try {
                Loader.show();
                let data = {
                    id: props?.configId,
                    TemplateName: titleName,
                    FinancialYear: selectedYear,
                    ClassId: className ? className.length > 1 ? className.join(',') : className[0] : '',
                    ToGivenBy: giver,
                    IsOverAllMarkLimit: overallLimit,
                    OverAllLimit: overallLimitMark,
                    IsSubjectMarkLimit: subjectLimit,
                    SubjectLimit: subjectLimitMark,
                    IsShowInResult: showInResult,
                    Symbol: symbol,
                    IsGraceMarkRemark: graceNote,
                    Remark: reMark,
                    CreatedBy: securityUserID,
                };
                await api
                    .post(APIConstant.path.AddUpdateGraceMarks, data)
                    .then((response) => {
                        let res = response;
                        if (res.success) {
                            Toast.success({ message: res.message });
                            Loader.hide();
                            onCancel();
                        } else {
                            Toast.error({ message: res.message });
                            Loader.hide();
                            onCancel();
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                        Loader.hide();
                        onCancel();
                    });
            } catch (err) {
                console.log(err);
                Toast.error({ message: err });
                Loader.hide();
                onCancel();
                catchResponse(err);
            }
        }
    };

    const handleChange = (value, type) => {
        const symbolValue = value.replace(/[a-zA-Z0-9\s]/g, '');
        const multiLangValue = value.replace(/[^a-zA-Z\u0A80-\u0AFF\u0900-\u097F\s]/g, '');
        const numericValue = value.replace(/[^0-9]/g, '');

        if (type === 'OverAllLimit') {
            setOverallLimitMark(numericValue);
        } else if (type === 'SubjectList') {
            setSubjectLimitMark(numericValue);
        } else if (type === 'Remark') {
            setRemark(multiLangValue);
        } else if (type === 'Symbol') {
            setSymbol(symbolValue);
        } else if (type === 'TitleName') {
            setTitleName(multiLangValue);
        }
    };

    return (
        <div className="p-d-flex p-flex-column p-jc-between p-overflow-hidden">
            <div style={{ maxHeight: 'calc(100vh - 260px)', overflow: 'auto' }}>
                <div className='p-grid'>
                    <div className="p-col-12 p-md-6 p-pt-2 e-add-fee-structure">
                        <div className="custom-inputs">
                            <label htmlFor="titleName">Name</label>
                            <FloatLabel>
                                <InputText
                                    ref={titleNameRef}
                                    className='p-w-100 p-mt-1'
                                    id="titleName"
                                    value={titleName}
                                    maxLength={20}
                                    onChange={(e) => handleChange(e.target.value, 'TitleName')}
                                    style={{
                                        fontFamily: "Noto Sans, Arial, sans-serif"
                                    }}
                                />
                            </FloatLabel>
                        </div>
                        <span className="error-msg" style={{ color: 'red' }}>
                            {titleNameErr ? titleNameErrText : null}
                        </span>
                    </div>
                    <div className="p-col-12 p-md-6 p-pt-2">
                        <div className="e-add-fee-structure">
                            <div className="custom-inputs">
                                <label htmlFor="className">Class</label>
                                <MultiSelect value={className} options={classList} onChange={(e) => setClassName(e.value)} multiple placeholder="Select Classes" display="chip" className='p-w-100 p-mt-1' filter />
                            </div>
                        </div>
                    </div>

                    <div className="p-col-12 p-md-6 p-pt-2">
                        <div className="custom-inputs">
                            <label htmlFor="className">To Be Given By</label>
                            <Dropdown value={giver} options={teachersList} onChange={(e) => setGiver(e.value)} placeholder="Select Giver" display="chip" className='p-w-100 p-mt-1' filter showClear />
                        </div>
                    </div>
                    <div className="p-col-12 p-md-6 p-pt-2">
                        <div className="custom-inputs">
                            <label htmlFor="selectedYear">Academic Years</label>
                            <Dropdown
                                id="selectedYear"
                                value={selectedYear}
                                options={props?.academicYearList}
                                onChange={(e) => setSelectedYear(e.value)}
                                placeholder="Select Academic Year"
                                display="chip"
                                className='p-w-100 p-mt-1'
                                filter
                                optionLabel="label"
                                optionValue="_id"
                                showClear
                            />
                        </div>
                    </div>
                    <div className="p-col-12 p-md-6 p-pt-2">
                        <div className="custom-inputs">
                            <label className="block font-semibold">Overall Grace Marks Limit</label>
                            <div className="p-d-flex p-ai-center p-my-2">
                                <div>
                                    <RadioButton inputId="overallYes" name="overallLimit" value={true} onChange={(e) => setOverallLimit(e.value)} checked={overallLimit === true} />
                                    <label htmlFor="overallYes" className="p-ml-2">Yes</label>
                                </div>
                                <div className="p-ml-6">
                                    <RadioButton inputId="overallNo" name="overallLimit" value={false} onChange={(e) => setOverallLimit(e.value)} checked={overallLimit === false} className="ml-4" />
                                    <label htmlFor="overallNo" className="p-ml-2">No</label>
                                </div>
                            </div>
                            <InputText value={overallLimitMark} maxLength={2} onChange={(e) => handleChange(e.target.value, 'OverAllLimit')} style={{
                                fontFamily: "Noto Sans, Arial, sans-serif"
                            }}
                                className='p-w-100 p-mt-1' disabled={!overallLimit} />

                        </div>
                    </div>

                    <div className="p-col-12 p-md-6 p-pt-2">
                        <div className="e-add-fee-structure">
                            <div className="custom-inputs">
                                <label className="block font-semibold">Subject-wise Grace Marks Limit</label>
                                <div className="p-d-flex p-ai-center p-my-2">
                                    <div>
                                        <RadioButton inputId="subjectYes" name="subjectLimit" value={true} onChange={(e) => setSubjectLimit(e.value)} checked={subjectLimit === true} />
                                        <label htmlFor="subjectYes" className="p-ml-2">Yes</label>
                                    </div>
                                    <div className="p-ml-6">
                                        <RadioButton inputId="subjectNo" name="subjectLimit" value={false} onChange={(e) => setSubjectLimit(e.value)} checked={subjectLimit === false} className="ml-4" />
                                        <label htmlFor="subjectNo" className="p-ml-2">No</label>
                                    </div>
                                </div>
                                <InputText value={subjectLimitMark} maxLength={2} onChange={(e) => handleChange(e.target.value, 'SubjectList')} className="p-w-100 p-mt-1" disabled={!subjectLimit} />
                            </div>
                        </div>
                    </div>

                    <div className="p-col-12 p-md-6 p-pt-2">
                        <div className="e-add-fee-structure">
                            <div className="custom-inputs">
                                <label className="block font-semibold">Show in Result</label>
                                <div className="p-d-flex p-ai-center p-my-2">
                                    <div>
                                        <RadioButton inputId="showYes" name="showResult" value={true} onChange={(e) => setShowInResult(e.value)} checked={showInResult === true} />
                                        <label htmlFor="showYes" className="p-ml-2">Yes</label>
                                    </div>
                                    <div className="p-ml-6">
                                        <RadioButton inputId="showNo" name="showResult" value={false} onChange={(e) => setShowInResult(e.value)} checked={showInResult === false} className="ml-4" />
                                        <label htmlFor="showNo" className="p-ml-2">No</label>
                                    </div>
                                </div>
                                <InputText value={symbol} maxLength={1} onChange={(e) => handleChange(e.target.value, 'Symbol')} className="p-w-100 p-mt-1" placeholder="Symbol" disabled={!showInResult} />
                            </div>
                        </div>
                    </div>

                    <div className="p-col-12 p-md-6 p-pt-2">
                        <div className="custom-inputs">
                            <label className="block font-semibold">Grace Mark Note in Result</label>
                            <div className="p-d-flex p-ai-center p-my-2">
                                <div>
                                    <RadioButton inputId="noteYes" name="graceNote" value={true} onChange={(e) => setGraceNote(e.value)} checked={graceNote === true} />
                                    <label htmlFor="noteYes" className="p-ml-2">Yes</label>
                                </div>
                                <div className="p-ml-6">
                                    <RadioButton inputId="noteNo" name="graceNote" value={false} onChange={(e) => setGraceNote(e.value)} checked={graceNote === false} className="ml-4" />
                                    <label htmlFor="noteNo" className="p-ml-2">No</label>
                                </div>
                            </div>
                            <InputText value={reMark} maxLength={300} onChange={(e) => handleChange(e.target.value, 'Remark')} className="p-w-100 p-mt-1" placeholder="Remark" disabled={!graceNote} style={{
                                fontFamily: "Noto Sans, Arial, sans-serif"
                            }}
                                onKeyDown={(e) => {
                                    if (e.key === 'Tab' && !e.shiftKey) {
                                        e.preventDefault();
                                        if (submitButtonRef.current) {
                                            submitButtonRef.current.focus();
                                        }
                                    }
                                }} />
                        </div>
                    </div>
                </div>
            </div>
            <div className="dialog-footer p-d-flex p-ai-center p-jc-end p-pb-5">
                <Button className='p-m-0 btn-text-action-secondary p-m-1' label="Cancel" onClick={(e) => onCancel()} />
                <Button ref={submitButtonRef} className='p-m-0 btn-text-action-primary submit-focus' label="Save" onClick={(e) => AddUpdateTemplate()} />
            </div>
        </div>
    );
};

export default AddEditGraceMarkConfiguration;
